let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("hc4DE")]).then(() => parcelRequire('4ykLR'));